




























import { Vue, Component } from 'vue-property-decorator';
import Subtitle from '@/components/molecules/Typography/Subtitle.vue';
import Container from '@/components/atoms/Grid/Container.vue';
import Description from '@/components/molecules/Typography/Description.vue';
import TextInput from '@/components/TextInput/TextInput.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import { treatError } from '@/utils';
import eventBus from '@/utils/eventBus';
import FlagsService from '@/api/FlagsService';

@Component({
  components: {
    FilledButton,
    Description,
    Container,
    Subtitle,
    TextInput
  }
})
export default class NewTicketRequest extends Vue {
  service = new FlagsService();

  loading = false;

  async createNew() {
    try {
      this.loading = true;
      this.$notification('Success');
      this.closeModal();
    } catch (e) {
      this.$notification(treatError(e));
    } finally {
      this.loading = false;
    }
  }

  closeModal() {
    eventBus.$emit('setSideModalVisible', false);
  }
}
